// Manually selected public Google review excerpts, verified on October 2, 2026.
// Keep the wording and attribution faithful to the linked original reviews.
export const googleProfileUrl = 'https://share.google/xW3p2ncQWwCPagTLQ';

export const customerReviews = [
  {
    author: 'Aaron Meadows',
    rating: 5,
    excerpt: 'Quality work overall and he explained the process and scope of work clearly which I appreciated.',
    url: 'https://share.google/6aIYRcCJ5UYiu3Ff6',
  },
  {
    author: 'Christopher Rhodes',
    rating: 5,
    excerpt: 'Professional, dependable, and built-to-last quality from start to finish. Highly recommend.',
    url: 'https://share.google/IKxyKYoSOluTzyELS',
  },
  {
    author: 'M A',
    rating: 5,
    excerpt: 'Vic did an outstanding job. Friendly and respectful. Would gladly do business with him again for any future projects.',
    url: 'https://share.google/50vMOsRxaRstVgdt4',
  },
];
